<template>
  <article :class="['v2-stat', `v2-stat--${tone}`]">
    <div v-if="icon || $slots.icon" class="v2-stat__icon" aria-hidden="true">
      <slot name="icon">
        <v-icon v-if="icon" size="22" :color="iconColor">{{ icon }}</v-icon>
      </slot>
    </div>
    <div class="v2-stat__body">
      <p v-if="label" class="v2-label v2-label--sm v2-stat__label">{{ label }}</p>
      <p class="v2-stat__value">{{ value }}</p>
      <p v-if="hint" class="v2-caption v2-stat__hint">{{ hint }}</p>
    </div>
  </article>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], required: true },
    hint: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "primary" },
    tone: {
      type: String,
      default: "neutral",
      validator: (v) => ["primary", "success", "warning", "error", "neutral"].includes(v),
    },
  },
};
</script>

<style scoped>
.v2-stat {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-5);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  min-height: 96px;
}

.v2-stat__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  flex-shrink: 0;
}

.v2-stat--primary .v2-stat__icon { background-color: var(--color-primary-soft); color: var(--color-primary); }
.v2-stat--success .v2-stat__icon { background-color: var(--color-success-soft); color: var(--color-success); }
.v2-stat--warning .v2-stat__icon { background-color: var(--color-warning-soft); color: var(--color-warning); }
.v2-stat--error   .v2-stat__icon { background-color: var(--color-error-soft);   color: var(--color-error); }
.v2-stat--neutral .v2-stat__icon { background-color: var(--color-neutral-100);  color: var(--color-neutral-700); }

.v2-stat__body {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  flex: 1 1 auto;
}

.v2-stat__label {
  color: var(--color-text-muted);
  margin: 0;
}

.v2-stat__value {
  font-family: var(--font-headline);
  font-size: var(--fs-display-md);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-tight);
  color: var(--color-text);
  margin: 0;
  word-break: break-word;
}

.v2-stat__hint {
  color: var(--color-text-muted);
  margin: 0;
}
</style>
